import { render, staticRenderFns } from "./Curso.vue?vue&type=template&id=3850369c&scoped=true&lang=pug&"
import script from "./Curso.vue?vue&type=script&lang=js&"
export * from "./Curso.vue?vue&type=script&lang=js&"
import style0 from "./Curso.styl?vue&type=style&index=0&id=3850369c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3850369c",
  null
  
)

export default component.exports